import React, { useState } from 'react';
import { ReactComponent as Logo } from 'assets/common/Logo-Red.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';
import HeaderTab from './tabs';
import User from './user';
import Sidebar from '../sidebar';
import CokitchenDropdown from './cokitchen-dropdown';

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header>
      <div className='container max-sm:px-4 md:px-4 flex flex-wrap justify-between mx-auto items-center'>
        <div className='flex gap-4 items-center'>
          <span className='lg:hidden my-4 w-8 h-8 rounded-full border border-gray-5 inline-flex justify-center items-center'>
            <MenuIcon className='w-5 h-5' onClick={() => setIsOpen(true)} />
          </span>
          <div className='flex flex-col gap-1 justify-center items-start'>
            <Logo />
            <CokitchenDropdown />
          </div>
        </div>
        <div className='hidden lg:block'>
          <HeaderTab />
        </div>
        <User />
      </div>
      <hr className='text-[#DCE2EA]' />
      <Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </header>
  );
};
